import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

export default function ConversionActions({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchConversionActions(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="h-24 bg-gray-200 rounded"></div>
      </div>
    );
  }

  if (!data?.actions?.length || data.actions.length <= 1) return null;

  const total = data.actions.reduce((s, a) => s + a.conversions, 0);
  const primaryColor = brand.colors?.primary || '#2563eb';

  const COLORS = [primaryColor, '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Conversion Breakdown
      </h3>
      <p className="text-xs text-gray-400 mb-4">Conversions by action type</p>

      <div className="space-y-3">
        {data.actions.map((action, i) => {
          const pct = total > 0 ? (action.conversions / total) * 100 : 0;
          const color = COLORS[i % COLORS.length];

          return (
            <div key={action.name} className="space-y-1.5">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-900 truncate mr-2">{action.name}</span>
                <span className="text-xs text-gray-500 whitespace-nowrap">
                  {action.conversions} ({pct.toFixed(0)}%)
                </span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2">
                <div
                  className="h-2 rounded-full transition-all duration-500"
                  style={{ width: `${pct}%`, backgroundColor: color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
